// Management authentication credentials (UI-only)
export const MANAGEMENT_CREDENTIALS = {
  username: 'admin',
  password: 'admin123'
};

export default MANAGEMENT_CREDENTIALS;